/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataMessageResponse_OtherPreferences_ } from "../models/DataMessageResponse_OtherPreferences_";
import type { DataResponse_OtherPreferences_ } from "../models/DataResponse_OtherPreferences_";
import type { OtherPreferences } from "../models/OtherPreferences";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class OtherPreferencesService {
  /**
   * Update Other Preferences
   * Updates the other preferences for a user.
   * Only updates fields that are explicitly provided; merges with existing values.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_OtherPreferences_ Successful Response
   * @throws ApiError
   */
  public static updateOtherPreferencesApiV1OtherPreferencesPut(
    xUserId: string,
    requestBody: OtherPreferences,
  ): CancelablePromise<DataMessageResponse_OtherPreferences_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/other-preferences",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Other Preferences
   * Returns the other preferences for a user.
   * @param xUserId
   * @returns DataResponse_OtherPreferences_ Successful Response
   * @throws ApiError
   */
  public static getOtherPreferencesApiV1OtherPreferencesGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_OtherPreferences_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/other-preferences",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Other Preferences By Admin
   * Used by an admin to get information about a user's other preferences.
   * @param userId
   * @returns DataResponse_OtherPreferences_ Successful Response
   * @throws ApiError
   */
  public static getOtherPreferencesByAdminApiV1OtherPreferencesUserIdGet(
    userId: string,
  ): CancelablePromise<DataResponse_OtherPreferences_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/other-preferences/{user_id}",
      path: {
        user_id: userId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
